// extracted by mini-css-extract-plugin
export default {"crownRain":"KingEffects_crownRain__szCfl","crown":"KingEffects_crown__sY0jI","crownFall":"KingEffects_crownFall__JRw8W","muteButton":"KingEffects_muteButton__B64Bj"};